import React from "react";

const MAP = {
  Pending:      { bg: "rgba(245,158,11,0.10)", fg: "#F59E0B", bd: "rgba(245,158,11,0.35)" },
  Verified:     { bg: "rgba(16,185,129,0.10)", fg: "#10B981", bd: "rgba(16,185,129,0.35)" },
  Rejected:     { bg: "rgba(244,63,94,0.10)",  fg: "#F43F5E", bd: "rgba(244,63,94,0.35)" },
  Approved:     { bg: "rgba(16,185,129,0.10)", fg: "#10B981", bd: "rgba(16,185,129,0.35)" },
  Open:         { bg: "rgba(59,130,246,0.10)", fg: "#60A5FA", bd: "rgba(59,130,246,0.35)" },
  Applied:      { bg: "rgba(148,163,184,0.10)", fg: "#94A3B8", bd: "rgba(148,163,184,0.35)" },
  Allocated:    { bg: "rgba(59,130,246,0.12)", fg: "#3B82F6", bd: "rgba(59,130,246,0.4)" },
  "Check-in Open":{ bg: "rgba(6,182,212,0.10)", fg: "#22D3EE", bd: "rgba(6,182,212,0.35)" },
  "In Progress":{ bg: "rgba(59,130,246,0.10)", fg: "#60A5FA", bd: "rgba(59,130,246,0.35)" },
  Submitted:    { bg: "rgba(168,85,247,0.10)", fg: "#A78BFA", bd: "rgba(168,85,247,0.35)" },
  "Revision Required":{ bg: "rgba(245,158,11,0.10)", fg: "#F59E0B", bd: "rgba(245,158,11,0.35)" },
  Completed:    { bg: "rgba(16,185,129,0.10)", fg: "#10B981", bd: "rgba(16,185,129,0.35)" },
  Paid:         { bg: "rgba(16,185,129,0.14)", fg: "#34D399", bd: "rgba(16,185,129,0.4)" },
  Shortlisted:  { bg: "rgba(59,130,246,0.10)", fg: "#60A5FA", bd: "rgba(59,130,246,0.35)" },
  "Under Review":{ bg: "rgba(148,163,184,0.10)", fg: "#94A3B8", bd: "rgba(148,163,184,0.35)" },
};

export const StatusBadge = ({ status, className = "", testId }) => {
  const c = MAP[status] || MAP.Open;
  return (
    <span
      data-testid={testId}
      className={`chip ${className}`}
      style={{ background: c.bg, color: c.fg, borderColor: c.bd }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: c.fg }} />
      {status}
    </span>
  );
};

export default StatusBadge;
